import { VisualizatorSettings } from "../../visualizator-settings";
import { ObjectCreator } from "../../../../../../../web-graphics";

export class IsolinePlotSettings extends VisualizatorSettings {
  constructor(settings) {
    super();
    for (const key of Object.getOwnPropertyNames(settings)) {
      if (key == "id" || key == "updateBorder") {
        this[key] = settings[key];
      } else if (key == "y") {
        this.y = settings.y.copy();
      } else if (key == "color") {
        this.color = ObjectCreator.deepCopy(settings.color);
      } else {
        if (typeof settings[key] === "object" && settings[key].copy !== undefined) {
          this[key] = settings[key].copy();
        } else if (typeof settings[key] !== "function") {
          this[key] = ObjectCreator.deepCopy(settings[key]);
        }
      }
    }
  }

  copy() {
    return new IsolinePlotSettings(this);
  }
}
